/** Tiny classname join utility (like clsx). */
export function cn(...args) {
  return args.filter(Boolean).join(' ');
}
